import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../../../../../translation/namespace';

type EmptyListItemProps = {
  displayText?: string;
};

export default function ListItemEmpty({ displayText = 'noResults' }: EmptyListItemProps = {}) {
  const { t } = useTranslation(Namespace.FormsComboBox);
  return (
    <div className="combobox__listbox-item">
      <div className="combobox__listbox-item-no-results">{t(displayText)}</div>
    </div>
  );
}
